import Vue from 'vue'
import Router from 'vue-router'
import startPage from '@/components/startPage'
import stepOrder from '@/components/stepOrder'
import schedule from '@/components/steps/schedule'
import order from '@/components/steps/order'
import payment from '@/components/steps/payment'
import review from '@/components/steps/review'
import registerFirst from '@/components/Register/registerFirst'
import Signup from '@/components/Register/Signup'
import signin from '@/components/Register/signin'
import search from '@/components/steps/search'
Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'startPage',
    //   component: startPage
    // },
    {
      path: '/',
      component: stepOrder,
      children:[
        {
          path: '/',
          name: 'schedule',
          component: schedule
        },
        {
          path:'/order',
          name:'order',
          component:order
        },
        {
          path:'/payment',
          name:'payment',
          component:payment

        },
        {
          path:'/search',
          name:'search',
          component:search
        }
        
      ]
    },
    {
      path:'/review',
      name:'review',
      component:review
    },
    {
      path:'/registerFirst',
      name:'registerFirst',
      component:registerFirst,
     
    },
    {
      path:'/signup',
      name:'Signup',
      component:Signup
    },
    {
      path:'/signin',
      name:'signin',
      component:signin
    },
    {
      path: '/startPage',
      name: 'startPage',
      component: startPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js